export default "__VITE_ASSET__LJRj07nv__"